module.exports = __webpack_public_path__ + "static/media/oops.d3977f08.svg";